import { ReactNode } from 'react';

import { MainPaneContainer } from './TwoPaneLayout.styled';

interface MainPaneProps {
  children: ReactNode;
}

const MainPane = ({ children }: MainPaneProps) => {
  return <MainPaneContainer>{children}</MainPaneContainer>;
};

export default MainPane;
